import React from 'react';
import styles from './TriggerBtn.module.scss';
import cls from 'classnames';

function TriggerBtn({onClick, rotateIcon, text, icon, circle, lgIcon, className}) {
  return (
    <button
      className={cls(
        styles.triggerBtn,
        {[styles.rotateIcon]: rotateIcon},
        {[styles.circle]: circle},
        {[styles.lgIcon]: lgIcon},
        className,
      )}
      onClick={onClick}
    >
      {text && (
        <span>{text}</span>
      )}
      {icon && (
        <i>{icon}</i>
      )}
    </button>
  );
}

export default TriggerBtn;
